// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditStaticPage-space1-ERBwK {
	margin-bottom: 6px !important;
}

.EditStaticPage-space2-E1QA6 {
	margin-bottom: 12px !important;
}

.EditStaticPage-space3-VDYgY {
	margin-bottom: 18px !important;
}

.EditStaticPage-space4-uLwiU {
	margin-bottom: 24px !important;
}

.EditStaticPage-space5-K7soL {
	margin-bottom: 30px !important;
}

.EditStaticPage-space6-sr9h2 {
	margin-bottom: 36px !important;
}

.EditStaticPage-space7-vd_YR {
	margin-bottom: 42px !important;
}

.EditStaticPage-space8-o3lLm {
	margin-bottom: 48px !important;
}

.EditStaticPage-spaceTop1-Iskon {
	margin-top: 6px !important;
}

.EditStaticPage-spaceTop2-AgoSk {
	margin-top: 12px !important;
}

.EditStaticPage-spaceTop3-WSi6m {
	margin-top: 18px !important;
}

.EditStaticPage-spaceTop4-WREmT {
	margin-top: 24px !important;
}

.EditStaticPage-spaceTop5-crg7j {
	margin-top: 30px !important;
}

.EditStaticPage-spaceTop6-DCnV9 {
	margin-top: 36px !important;
}

.EditStaticPage-spaceTop7-bdX3z {
	margin-top: 42px !important;
}

.EditStaticPage-spaceTop8-Y664t {
	margin-top: 48px !important;
}

.EditStaticPage-noMargin-ABZp5 {
	margin: 0px !important;
}

.EditStaticPage-padding1-tQKpt {
	padding-bottom: 6px !important;
}

.EditStaticPage-padding2-NvUdi {
	padding-bottom: 12px !important;
}

.EditStaticPage-padding3-LsBjD {
	padding-bottom: 18px !important;
}

.EditStaticPage-padding4-UNKeq {
	padding-bottom: 24px !important;
}

.EditStaticPage-padding5-zgmpz {
	padding-bottom: 30px !important;
}

.EditStaticPage-padding6-_wBLK {
	padding-bottom: 36px !important;
}

.EditStaticPage-padding7-tO7nS {
	padding-bottom: 42px !important;
}

.EditStaticPage-paddingTop1-p65f0 {
	padding-top: 6px !important;
}

.EditStaticPage-paddingTop2-HDaqi {
	padding-top: 12px !important;
}

.EditStaticPage-paddingTop3-Slejt {
	padding-top: 18px !important;
}

.EditStaticPage-paddingTop4-UDBww {
	padding-top: 24px !important;
}

.EditStaticPage-paddingTop5-ZrkMt {
	padding-top: 30px !important;
}

.EditStaticPage-paddingTop6-BBVMG {
	padding-top: 36px !important;
}

.EditStaticPage-paddingTop7-FzWmE {
	padding-top: 42px !important;
}

.EditStaticPage-noPadding-ZqDY_ {
	padding: 0px !important;
}

.EditStaticPage-spaceMarginBottom0-ZnQFo {
	margin-bottom: 0;
}

.EditStaticPage-textBold-c08Q4 {
	font-weight: 500 !important;
}

.EditStaticPage-textBolder-DlsfR {
	font-weight: 700 !important;
}

.EditStaticPage-textNormal-xIgyv {
	font-weight: normal !important;
}

/*New Design Text Colors */

.EditStaticPage-textDarkBlue-Cb32J {
	color: rgb(20, 39, 94) !important;
}

.EditStaticPage-textLightBlue-WZGqK {
	color: rgb(57, 87, 106) !important;
}

.EditStaticPage-textLightSandleGreen-SaqlD {
	color: rgb(76, 86, 41) !important;
}

.EditStaticPage-textLightBrown-SqdH9 {
	color: rgb(115, 79, 33) !important;
}

.EditStaticPage-textMediumMaroon-jfdPn {
	color: rgb(87, 37, 51) !important;
}

.EditStaticPage-textBrown-kOHt_ {
	color: rgb(160, 47, 24) !important;
}

.EditStaticPage-textMaroon-omgI_ {
	color: rgb(155, 49, 67) !important;
}

.EditStaticPage-textDarkBrown-Eh_t8 {
	color: rgb(83, 18, 16) !important;
}

.EditStaticPage-textMediumBrown-pU9wl {
	color: rgb(142, 28, 10) !important;
}

.EditStaticPage-textSkyBlue-aDhDY {
	color: rgb(37, 117, 141) !important;
}

.EditStaticPage-textGray-xDzmq {
	color: rgb(77, 65, 51) !important;
}

.EditStaticPage-errorMessage-aTCZ3 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.EditStaticPage-userText-fjVnl {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.EditStaticPage-panelHeader-R3u5F {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.EditStaticPage-exportSection-tZjUa {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.EditStaticPage-exportSectionGridSub-DJu6C {
	grid-template-columns: 50% 49% !important;
}

.EditStaticPage-exportText-ChuCb {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.EditStaticPage-exportLinkImg-N9WsV {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.EditStaticPage-exportImg-CTOUt {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditStaticPage-linkBtn-QkzPk {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.EditStaticPage-table-yeJaA {
	display: table;
}

.EditStaticPage-tableRow-CNzb7 {
	display: table-row;
}

.EditStaticPage-tableCell-TfVts {
	display: table-cell;
	float: none;
}

.EditStaticPage-formGroup-Tiyi9 {
	margin-bottom: 6px;
}

.EditStaticPage-marginTop0-GlGcX {
	margin-top: 0;
}

.EditStaticPage-marginBottom20-raXEG {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.EditStaticPage-bannerImageBg-Hw0hh {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.EditStaticPage-bannerDelete-Vq8AL {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.EditStaticPage-exportLink-yFipV {
	padding-top: 10px;
	padding-right: 10px;
}

.EditStaticPage-seachContent-PaVos {
	padding-left: 0px;
	margin-bottom: 5px;
}

.EditStaticPage-marginBottom9-SprAT {
	margin-bottom: 9px;
}

.EditStaticPage-spaceTop52-kdwAf {
	margin-top: 52px;
}

.EditStaticPage-profileViewInner-YQYQy {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.EditStaticPage-profileViewMain-GZbuH {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.EditStaticPage-profileViewlabel-c37s1 {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.EditStaticPage-profileViewMainContent-ze46e {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.EditStaticPage-reviewsFormStar-uWiP1 {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.EditStaticPage-reviewsFormStar-uWiP1 svg {
	cursor: pointer;
}

.EditStaticPage-addLanguageText-ICtvf {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.EditStaticPage-exportSection-tZjUa {
		grid-template-columns: 100%;
	}

	.EditStaticPage-spaceTop52-kdwAf {
		margin-top: 18px;
	}

	.EditStaticPage-exportText-ChuCb {
		float: none;
		margin-top: 12px;
	}

	.EditStaticPage-exportSectionGridSub-DJu6C {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.EditStaticPage-profileViewlabel-c37s1 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditStaticPage-profileViewMainContent-ze46e {
		width: 100%;
		text-align: center;
	}

	.EditStaticPage-panelHeader-R3u5F {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EditStaticPage-space1-ERBwK`,
	"space2": `EditStaticPage-space2-E1QA6`,
	"space3": `EditStaticPage-space3-VDYgY`,
	"space4": `EditStaticPage-space4-uLwiU`,
	"space5": `EditStaticPage-space5-K7soL`,
	"space6": `EditStaticPage-space6-sr9h2`,
	"space7": `EditStaticPage-space7-vd_YR`,
	"space8": `EditStaticPage-space8-o3lLm`,
	"spaceTop1": `EditStaticPage-spaceTop1-Iskon`,
	"spaceTop2": `EditStaticPage-spaceTop2-AgoSk`,
	"spaceTop3": `EditStaticPage-spaceTop3-WSi6m`,
	"spaceTop4": `EditStaticPage-spaceTop4-WREmT`,
	"spaceTop5": `EditStaticPage-spaceTop5-crg7j`,
	"spaceTop6": `EditStaticPage-spaceTop6-DCnV9`,
	"spaceTop7": `EditStaticPage-spaceTop7-bdX3z`,
	"spaceTop8": `EditStaticPage-spaceTop8-Y664t`,
	"noMargin": `EditStaticPage-noMargin-ABZp5`,
	"padding1": `EditStaticPage-padding1-tQKpt`,
	"padding2": `EditStaticPage-padding2-NvUdi`,
	"padding3": `EditStaticPage-padding3-LsBjD`,
	"padding4": `EditStaticPage-padding4-UNKeq`,
	"padding5": `EditStaticPage-padding5-zgmpz`,
	"padding6": `EditStaticPage-padding6-_wBLK`,
	"padding7": `EditStaticPage-padding7-tO7nS`,
	"paddingTop1": `EditStaticPage-paddingTop1-p65f0`,
	"paddingTop2": `EditStaticPage-paddingTop2-HDaqi`,
	"paddingTop3": `EditStaticPage-paddingTop3-Slejt`,
	"paddingTop4": `EditStaticPage-paddingTop4-UDBww`,
	"paddingTop5": `EditStaticPage-paddingTop5-ZrkMt`,
	"paddingTop6": `EditStaticPage-paddingTop6-BBVMG`,
	"paddingTop7": `EditStaticPage-paddingTop7-FzWmE`,
	"noPadding": `EditStaticPage-noPadding-ZqDY_`,
	"spaceMarginBottom0": `EditStaticPage-spaceMarginBottom0-ZnQFo`,
	"textBold": `EditStaticPage-textBold-c08Q4`,
	"textBolder": `EditStaticPage-textBolder-DlsfR`,
	"textNormal": `EditStaticPage-textNormal-xIgyv`,
	"textDarkBlue": `EditStaticPage-textDarkBlue-Cb32J`,
	"textLightBlue": `EditStaticPage-textLightBlue-WZGqK`,
	"textLightSandleGreen": `EditStaticPage-textLightSandleGreen-SaqlD`,
	"textLightBrown": `EditStaticPage-textLightBrown-SqdH9`,
	"textMediumMaroon": `EditStaticPage-textMediumMaroon-jfdPn`,
	"textBrown": `EditStaticPage-textBrown-kOHt_`,
	"textMaroon": `EditStaticPage-textMaroon-omgI_`,
	"textDarkBrown": `EditStaticPage-textDarkBrown-Eh_t8`,
	"textMediumBrown": `EditStaticPage-textMediumBrown-pU9wl`,
	"textSkyBlue": `EditStaticPage-textSkyBlue-aDhDY`,
	"textGray": `EditStaticPage-textGray-xDzmq`,
	"errorMessage": `EditStaticPage-errorMessage-aTCZ3`,
	"userText": `EditStaticPage-userText-fjVnl`,
	"panelHeader": `EditStaticPage-panelHeader-R3u5F`,
	"exportSection": `EditStaticPage-exportSection-tZjUa`,
	"exportSectionGridSub": `EditStaticPage-exportSectionGridSub-DJu6C`,
	"exportText": `EditStaticPage-exportText-ChuCb`,
	"exportLinkImg": `EditStaticPage-exportLinkImg-N9WsV`,
	"exportImg": `EditStaticPage-exportImg-CTOUt`,
	"linkBtn": `EditStaticPage-linkBtn-QkzPk`,
	"table": `EditStaticPage-table-yeJaA`,
	"tableRow": `EditStaticPage-tableRow-CNzb7`,
	"tableCell": `EditStaticPage-tableCell-TfVts`,
	"formGroup": `EditStaticPage-formGroup-Tiyi9`,
	"marginTop0": `EditStaticPage-marginTop0-GlGcX`,
	"marginBottom20": `EditStaticPage-marginBottom20-raXEG`,
	"bannerImageBg": `EditStaticPage-bannerImageBg-Hw0hh`,
	"bannerDelete": `EditStaticPage-bannerDelete-Vq8AL`,
	"exportLink": `EditStaticPage-exportLink-yFipV`,
	"seachContent": `EditStaticPage-seachContent-PaVos`,
	"marginBottom9": `EditStaticPage-marginBottom9-SprAT`,
	"spaceTop52": `EditStaticPage-spaceTop52-kdwAf`,
	"profileViewInner": `EditStaticPage-profileViewInner-YQYQy`,
	"profileViewMain": `EditStaticPage-profileViewMain-GZbuH`,
	"profileViewlabel": `EditStaticPage-profileViewlabel-c37s1`,
	"profileViewMainContent": `EditStaticPage-profileViewMainContent-ze46e`,
	"reviewsFormStar": `EditStaticPage-reviewsFormStar-uWiP1`,
	"addLanguageText": `EditStaticPage-addLanguageText-ICtvf`
};
module.exports = ___CSS_LOADER_EXPORT___;
